import axios from "axios";

export const GeoTagging = async (token) => {
  try {
    const response = await axios.get("agency/field-agents/", {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },                                                                                                                                                
    });
    return response.data;
  } catch (error) {

    return error;
  }
};
